// Storefront Bearer token. "Remember me" decides where it lives:
//   remembered  -> localStorage (survives browser restarts)
//   session     -> sessionStorage (cleared when the tab/window closes)
// An in-memory cache keeps reads cheap and works even when Web Storage throws
// (private mode, disabled cookies) — the session then lasts until reload.

const STORAGE_KEY = 'ayat_token';

let cached;

function readFromStorage() {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export const tokenManager = {
  get() {
    if (cached === undefined) cached = readFromStorage();
    return cached;
  },
  set(token, { remember = false } = {}) {
    cached = token;
    try {
      localStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
      (remember ? localStorage : sessionStorage).setItem(STORAGE_KEY, token);
    } catch {
      /* storage unavailable — token stays in memory for this session only */
    }
  },
  clear() {
    cached = null;
    try {
      localStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
  },
};
